<template>
    <div class="check-text-box">
        <div v-for="(val, k) in check_password_text" :key="k"
            :class="['check-text', val.is_correct && 'check-text-green', (!val.is_correct && is_error) && 'check-text-red']">
            {{ val.text }} <i>
                <SvgIcon :name="(val.is_correct || (!val.is_correct && !is_error)) ? 'yes' : 'alert'" class="icon-left" />
            </i>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon.vue';

export default {
    name: 'CheckFieldText',

    data() {
        return {
        }
    },

    components: {
        SvgIcon,
    },

    props: {
        check_password_text: {
            type: Array,
        },
        is_error: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
    },
}

</script>

<style lang="scss">
.check-text-box {
    margin: 20px 0;
    font-family: var(--font);
    font-size: 12px;
    font-weight: 500;

    .check-text {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: var(--black-50);

        i {
            width: 14px;
            height: 14px;
            margin-left: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        svg {
            width: 10.5px;
            height: 10.5px;
            fill: var(--black-50);
        }

        &.check-text-green {
            color: var(--green);

            svg {
                fill: var(--green);
            }
        }

        &.check-text-red {
            color: var(--alert);

            svg {
                fill: var(--alert);
            }
        }
    }
}
</style>